import getConfig from "next/config"
import { useRouter } from "next/router"
import { ChangeEvent, FormEvent, useState } from "react"
import { t } from "translations"

import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import { IMegamenuCategory } from "data/contentData/interfaces/IMegamenuCategory"
import { IContainerCard } from "data/contentData/interfaces/mongodb/IContainerCard"
import { getStaticLayoutProps } from "lib/getStaticLayoutProps"

import Layout from "Components/Layout/Layout"
import useGtmCustomVariables from "lib/hooks/useGtmCustomVariables"

export default function ArticleExpired({
    footer,
    megamenu
}: {
    footer: IContainerCard[]
    megamenu: IMegamenuCategory[]
}) {
    const router = useRouter()
    useGtmCustomVariables()
    const [term, setTerm] = useState("")
    const searchQuery = (router.query.q as string)?.trim()
    const { publicRuntimeConfig } = getConfig()

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setTerm(event.target.value)
    }
    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        router.push(`${publicRuntimeConfig.searchPath}?q=${term}`)
        event.preventDefault()
    }

    return (
        <Layout
            footer={footer}
            megamenu={megamenu}>
            <StyledContainer>
                <Typography variant="h1">{t.articleExpired.title}</Typography>
                <Typography variant="h4">
                    {t.articleExpired.subheader}
                </Typography>
                <StyledSearchContainer>
                    <StyledForm onSubmit={onSubmit}>
                        <TextField
                            variant="outlined"
                            label={t.notFound.searchInputLabel}
                            onChange={onChange}
                            defaultValue={searchQuery || ""}
                        />
                        <Button
                            variant="contained"
                            size="large">
                            {t.search.title}
                        </Button>
                    </StyledForm>
                </StyledSearchContainer>
            </StyledContainer>
        </Layout>
    )
}

const StyledContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    paddingTop: theme.spacing(10),
    textAlign: "center",
    background: theme.palette.common.white,
    minHeight: "calc(80vh -  511px)"
}))

const StyledSearchContainer = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: `${theme.spacing(10)} auto`,
    [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(10)
    }
}))

const StyledForm = styled("form")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
        flexDirection: "row"
    }
}))

export const getStaticProps = getStaticLayoutProps
